<section class="mat-typography">
    <ng-container *ngIf="edit; then editMode else viewMode"></ng-container>
</section>

<ng-template #editMode>
    <form [formGroup]="formGroup"
          (submit)="formGroup.valid &&
                      formGroup.dirty &&
                      submitUser.emit(user)"
          class="user-profile-edit-container">
        <mat-form-field>
            <input [placeholder]="'profile_general_name' | translate"
                   [readonly]="isLoading"
                   matInput
                   formControlName="name"
                   name="name"
                   data-cy="user-profile-edit-name" />
            <mat-hint *ngIf="!formGroup.get('name')!.pristine &&
                            formGroup.get('name')!.hasError('maxlength')"
                      translate
                      [translateParams]="{
                        max: formGroup.get('name')!.getError('maxlength').requiredLength
                      }"
                      class="errorMessage">
                profile_general_name_max_warning
            </mat-hint>
        </mat-form-field>
        <mat-form-field>
            <input [placeholder]="'profile_general_surname' | translate"
                   [readonly]="isLoading"
                   matInput
                   formControlName="surname"
                   name="surname"
                   data-cy="user-profile-edit-surname" />
            <mat-hint *ngIf="!formGroup.get('surname')!.pristine &&
                            formGroup.get('surname')!.hasError('maxlength')"
                      translate
                      [translateParams]="{
                        max: formGroup.get('surname')!.getError('maxlength').requiredLength
                      }"
                      class="errorMessage">
                profile_general_surname_max_warning
            </mat-hint>
        </mat-form-field>
        <mat-form-field>
            <input [placeholder]="'profile_general_email' | translate"
                   [readonly]="isLoading || disallowEmailChange"
                   matInput
                   formControlName="emailAddress"
                   name="emailAddress"
                   data-cy="user-profile-edit-email" />
            <mat-hint *ngIf="!formGroup.get('emailAddress')!.pristine &&
                            !formGroup.get('emailAddress')!.hasError('email') &&
                            formGroup.get('emailAddress')!.hasError('maxlength')"
                      translate
                      [translateParams]="{
                        max: formGroup.get('emailAddress')!.getError('maxlength').requiredLength
                      }"
                      class="errorMessage">
                profile_general_email_max_warning
            </mat-hint>
            <mat-hint *ngIf="!formGroup.get('emailAddress')!.pristine &&
                            formGroup.get('emailAddress')!.hasError('email')"
                      translate
                      class="errorMessage">
                profile_general_email_invalid_warning
            </mat-hint>
        </mat-form-field>
        <div class="tab-footer">
            <button [spinnerButtonLoading]="isLoading"
                    [disabled]="isLoading ||
                                formGroup.invalid ||
                                formGroup.pristine"
                    ui-spinner-button
                    mat-flat-button
                    type="submit"
                    color="primary"
                    data-cy="user-profile-general-submit">
                {{ 'modal_action_update' | translate }}
            </button>
        </div>
    </form>
</ng-template>
<ng-template #viewMode>
    <ng-container *ngTemplateOutlet="displayedValue; context: {
        label: 'profile_general_tenancy' | translate,
        value: user.tenantDisplayName,
        selector: 'user-profile-tenancy'
    }"></ng-container>
    <ng-container *ngTemplateOutlet="displayedValue; context: {
        label: 'profile_general_username' | translate,
        value: user.userName,
        selector: 'user-profile-username'
    }"></ng-container>
    <ng-container *ngTemplateOutlet="displayedValue; context: {
        label: 'profile_general_name' | translate,
        value: user.name,
        selector: 'user-profile-name'
    }"></ng-container>
    <ng-container *ngTemplateOutlet="displayedValue; context: {
        label: 'profile_general_surname' | translate,
        value: user.surname,
        selector: 'user-profile-surname'
    }"></ng-container>
    <ng-container *ngTemplateOutlet="displayedValue; context: {
        label: 'profile_general_email' | translate,
        value: user.emailAddress,
        selector: 'user-profile-email'
    }"></ng-container>
    <div *ngIf="isActiveUser"
         class="setting-info">
        <span class="setting-label">
            {{ 'theme_placeholder' | translate }}:
        </span>

        <mat-radio-group [ngModel]="theme$ | async"
                         class="theme-preview-container">

            <div *ngIf="hasSupportForPrefersColorScheme"
                 class="theme-item theme-cutout">
                <ui-theme-preview [theme]="themes[0]"
                                  (select)="changeTheme(autoTheme)"
                                  class="theme-cutout-light">
                </ui-theme-preview>
                <ui-theme-preview [theme]="themes[1]"
                                  (select)="changeTheme(autoTheme)"
                                  class="theme-cutout-dark">
                </ui-theme-preview>

                <mat-radio-button [value]="autoTheme"
                                  (change)="changeTheme(autoTheme)">
                    {{ ('theme_auto') | translate }}
                </mat-radio-button>
            </div>

            <div *ngFor="let theme of themes"
                 class="theme-item">
                <ui-theme-preview [theme]="theme"
                                  (select)="changeTheme($event)">
                </ui-theme-preview>
                <mat-radio-button [value]="theme"
                                  (change)="changeTheme($event.value)">
                    {{ ('theme_' + theme) | translate }}
                </mat-radio-button>
            </div>
        </mat-radio-group>
    </div>
</ng-template>

<ng-template #displayedValue
             let-label="label"
             let-value="value"
             let-selector="selector">
    <div class="setting-info">
        <span class="setting-label">{{label}}:</span>
        <ng-container *ngIf="value; else notAvailable">
            <span class="setting-value"
                  [attr.data-cy]="selector">{{value}}</span>
        </ng-container>
        <ng-template #notAvailable>
            <span class="setting-not-available"
                  [attr.data-cy]="selector">N/A</span>
        </ng-template>
    </div>
</ng-template>
